<template>
  <template v-if="$page">
    <div class="header gallery">
      <div class="header__content">
        <h1 class="title v-reveal v-reveal-active">{{ $page.header.title }}</h1>
        <div>{{ $page.header.description }}</div>
      </div>

      <SiteNav :sticky="false" @burger="burger" />
    </div>

    <div class="content gallery" id="g">
      <div class="content__tabs">
        <div class="tabs-selectors">
          <LangRouterLink
            :to="{ name: $route.name, query: { c: city.id }, hash: '#g' }"
            v-for="city in cities"
            :key="`city-${city.id}`"
            class="tab-selector"
            :data-active-tab="$route.query?.c === city.id.toString()"
          >
            <h3 class="title v-reveal v-reveal-active">{{ city.name }}</h3>
          </LangRouterLink>
        </div>
        <div v-if="city" class="gallery__image-container">
          <button
            v-for="(item, index) in city.gallery_images"
            :key="`image-${index}`"
            @click="$emit('imageViewer', city.gallery_images, index)"
          >
            <img :src="item.image.original" :alt="item.description" class="gallery__image" />
          </button>
        </div>
      </div>
    </div>
  </template>

  <template v-else>
    <div style="min-height: 100vh" />
  </template>
</template>

<script>
import LangRouterLink from '@/components/global/LangRouterLink.vue'
import SiteNav from '@/components/SiteNav.vue'
import seo from '@/helpers/mixins/seo.js'

export default {
  name: 'Gallery',
  beetPage: 'gallery',
  mixins: [seo],
  inject: ['mq'],
  emits: ['burger', 'imageViewer'],
  components: { LangRouterLink, SiteNav },
  computed: {
    cities() {
      return Object.values(this.$beet.cities).filter((city) => city.gallery_images?.length > 0)
    },
    city() {
      return this.$route.query.c ? this.$beet.cities[this.$route.query.c] : null
    },
  },
  methods: {
    burger() {
      this.$emit('burger')
    },
  },
  watch: {
    $beet: {
      handler() {
        if (this.$beet.cities && !this.$route.query.c) {
          this.$nextTick(() => {
            this.$router.push({ name: this.$route.name, query: { c: this.cities[0].id } })
          })
        }
      },
      immediate: true,
    },
  },
}
</script>
